<template>
  <div class="container-fluid">
    <div class="d-flex justify-content-between pb-3 align-items-center">
      <div>
        <div class="h3 font-weight-bold my-0">
          {{ $t($route.name.toLowerCase().replace(/ /g, '_') + ".plural") }}
        </div>
        <div class="text-muted my-0">
          <span class="text-primary">Home</span> / Administration / {{ $t($route.name.toLowerCase().replace(/ /g, '_') + ".plural") }}
        </div>
      </div>
      <div>
        <Button
          label="Add Template"
          icon="uil-plus mr-1"
          class="btn2 btn2-primary btn2-md mr-1 mb-3 mb-sm-0"
          @click="onAdd"
          v-if="role_modules.some(item => item.value == 'email.create')"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-xl-12">
      <DataTable ref="table" @onEdit="onEdit" />
      </div>
    </div>

    <Dialog
      customBtnClass="component-template"
      is_reset_model
      centered
      ref="createEmailTemplate"
      size="lg"
      yesText="Create"
      noText="Cancel"
      title="Create Template"
      :buttonDisable="created"
      :component="createEmailTemplateComponent"
      @onYes="onCreateTemplate"
      v-if="role_modules.some(item => item.value == 'email.create')"
    />
    <Dialog
      customBtnClass="component-template"
      autoload
      centered
      ref="editEmailTemplate"
      size="lg"
      yesText="Edit"
      noText="Cancel"
      title="Edit Template"
      :buttonDisable="updated"
      :parameters="{ templateID: selected._id ? selected._id : selected.id }"
      :component="editEmailTemplateComponent"
      @onYes="onEditEmailTemplate"
      v-if="role_modules.some(item => item.value == 'email.edit')"
    />
    <!-- <EmailFormModal @saved="onSave" :selected="selected" /> -->
  </div>
</template>

<script>
import Dialog from '@components/offcanvas'
import Button from '@components/buttons'
import DataTable from '@pages/administration/email/components/tables'

import error from '@utils/error'
// import EmailFormModal from '@pages/administration/email/modal/form'

export default {
  components: {
    DataTable,
    Dialog,
    Button
    // EmailFormModal
  },
  computed: {
    createEmailTemplateComponent() {
      return () => import('./components/dialogs/create')
    },
    editEmailTemplateComponent() {
      return () => import('./components/dialogs/edit')
    }
  },
  data(){
    return {
      selected:{},
      created: false,
      updated: false,
    }
  },
  methods:{
    onCreateTemplate(val) {
      this.created = true;
      let model = val && val.model && Object.entries(val.model).length ? val.model : val

      val.validateForm && val.validateForm();
      if (val.$v && val.$v.$error) {
        this.created = false;
        return error.errorHandler({ message: "Required field(s) must not be empty" }, this.$bvToast)
      }

      return this.$store.dispatch('email_template/create', model)
      .then(res => {
        if (res && res.data) {
          this.$refs.table.fetchData();
          this.$refs.createEmailTemplate.hide();
          this.$bvToast.toast('Email template successfully added!', {
            variant: 'success',
            title: "Notification"
          })
          setTimeout(() => {
            this.created = false;
          }, 1500)
        }
      })
      .catch(err => {
        this.created = false;
        return error.errorHandler(err, this.$bvToast);
      })
    },
    onEditEmailTemplate(val) {
      this.updated = true;
      let model = val && val.model && Object.entries(val.model).length ? val.model : val
      model.id = model._id ? model._id : model.id ? model.id : ''

      val.validateForm && val.validateForm();
      if (val && val.$v && val.$v.$error) {
        this.updated = false;
        return error.errorHandler({ message: "Required field(s) must not be empty" }, this.$bvToast)
      }

      return this.$store.dispatch('email_template/update', model)
      .then(res => {
        if (res && res.data) {
          this.$refs.table.fetchData();
          this.$refs.editEmailTemplate.hide();
          this.$bvToast.toast('Email template successfully updated!', {
            variant: 'success',
            title: "Notification"
          })
          setTimeout(() => {
            this.updated = false;
          }, 1500)
        }
      })
      .catch(err => {
        this.updated = false;
        return error.errorHandler(err, this.$bvToast);
      })
    },
    onAdd(){
      this.selected = {}
      this.$refs.createEmailTemplate.show()
    },
    onEdit(item){
      this.selected = item
      this.$refs.editEmailTemplate.show()
    }
  }
}
</script>